export default {
  data () {
    return {
      mixinTrack: null,
      mixinTouchCancle: false,
      mixinSliderLeft: 0,
      mixinNowLeft: 0,
      mixinTouchPoint: {
        startX: 0,
        endX: 0,
        startTime: 0,
        endTime: 0
      },
      mixinClicked: false,
      distance: 20,
      throttle : {
        delay : 1000,
        timer: null
      }
    }
  },

  beforeDestory () {
    this.mixinTrack.removeEventListener('mousedown', this._downEvent)
    this.mixinTrack.removeEventListener('mousemove', this._moveEvent)
    this.mixinTrack.removeEventListener('mouseup', this._upEvent)
    this.mixinTrack.removeEventListener('mouseleave', this._leaveEvent)
  },
  
  methods: {
    _mixinInit (el) {
      this.mixinTrack = el
      this.mixinTrack.addEventListener('mousedown', this._downEvent)
      this.mixinTrack.addEventListener('mousemove', this._moveEvent)
      this.mixinTrack.addEventListener('mouseup', this._upEvent)
      this.mixinTrack.addEventListener('mouseleave', this._leaveEvent)
    },

    _downEvent (e) {
      if (this.mixinTouchCancle) {
        return false
      }
      this.mixinNowLeft = this.mixinTrack.scrollLeft
      this.mixinTouchPoint.startX = e.pageX
      this.mixinTouchPoint.startTime = e.timeStamp
      this.mixinClicked = true
      e.preventDefault()
    },

    _moveEvent (e) {
      if (!this.mixinClicked) { return false }
      this.mixinSliderLeft = this.mixinNowLeft + (this.mixinTouchPoint.startX - e.pageX)
      this.mixinTrack.scrollLeft = this.mixinSliderLeft
    },

    _upEvent (e) {
      this.mixinTouchPoint.endX = e.pageX
      this.mixinTouchPoint.endTime = e.timeStamp

      if (Math.abs(this.mixinTouchPoint.startX - this.mixinTouchPoint.endX) > 20) {
        setTimeout(() => {
          this.mixinClicked = false
        }, 50)
      } else {
        this.mixinClicked = false
      }
    },

    _leaveEvent (e) {
      this.mixinTouchPoint.endTime = e.timeStamp

      if (Math.abs(this.mixinTouchPoint.startX - this.mixinTouchPoint.endX) > 20) {
        setTimeout(() => {
          this.mixinClicked = false
        }, 50)
      } else {
        this.mixinClicked = false
      }
    },

    _scrollEvent(){
      if(!this.swiperBusy && this.swiperCallback && this.mixinTrack.scrollWidth - this.mixinTrack.scrollLeft <= (this.mixinTrack.offsetWidth + this.distance)){
        if(!this.throttle.timer){
          this.throttle.timer = setTimeout(()=>{
            this.throttle.timer = null
            this.swiperCallback()
          }, this.throttle.delay)
        }
      }
    }
  }
}
